import React, { FC } from 'react'
import { connect } from 'react-redux'
import { EntityTypeEnum, WorkflowActions, CrudEventEnum, ProductDetail } from 'api'
import { Locale, Translation } from 'locale'
import { SplitButtonDropdown, ActionItem } from 'view/components/menus'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { CorrelatedResponseCallback } from 'store/notification/notificationTypes'
import { ProductDialog } from '../ProductDialog'

export interface ProductActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<ProductDetail> {
  onShowProductEntityDialog: (
    entityTypeEnum: EntityTypeEnum,
    entityId: string,
    correlatedResponseCallback?: CorrelatedResponseCallback
  ) => unknown
}

const mapDispatchToProps = {
  onShowProductEntityDialog: WorkflowActions.createEditWorkflow
}

export const ProductActionsButtonComponent: FC<ProductActionsButtonProps> = props => {
  const handleShowItemDialog = (entityId: string) => {
    const correlatedResponseCallback = (workflowId: string) => {
      props.showModal(<ProductDialog workflowId={workflowId} entityId={entityId} />)
    }
    props.onShowProductEntityDialog(EntityTypeEnum.PRODUCT, entityId, correlatedResponseCallback)
  }

  const canEditDetails = (item: ProductDetail) => {
    const isKnownProduct = !item.product.system
    return item.availableEvents.includes(CrudEventEnum.UPSERT) && isKnownProduct
  }

  const editItems = props.items.filter(item => canEditDetails(item))

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT_DETAILS),
      onClick: () => handleShowItemDialog(editItems[0].product.id),
      enabled: editItems.length === 1
    }
  ]

  return <SplitButtonDropdown dataTestId={'ProductActionsButton'} actions={actions} maxButtons={1} />
}

export const ProductActionsButton = withModal(connect(null, mapDispatchToProps)(ProductActionsButtonComponent))
